import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [bubbleAnimated, setBubbleAnimated] = useState(false);

  useEffect(() => {
    // Trigger entrance animations after component mounts
    const timer1 = setTimeout(() => setIsVisible(true), 200);
    const timer2 = setTimeout(() => setBubbleAnimated(true), 800);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  return (
    <div className="not-found-container">
      <div className={`not-found-content ${isVisible ? "visible" : ""}`}>
        <h1 className="not-found-title">
          <span className="not-found-404">404</span>
          <span className="not-found-text">Page Not Found</span>
        </h1>

        <p className="not-found-message">
          The page you're looking for doesn't exist.
        </p>

        <div
          className={`not-found-bubbles ${bubbleAnimated ? "animated" : ""}`}
        >
          <Link
            to="/"
            className="not-found-bubble home"
            data-interactive="true"
          >
            <span>Home</span>
          </Link>
          <Link
            to="/about"
            className="not-found-bubble about"
            data-interactive="true"
          >
            <span>About</span>
          </Link>
          <Link
            to="/photography"
            className="not-found-bubble photography"
            data-interactive="true"
          >
            <span>Photography</span>
          </Link>
          <Link
            to="/media"
            className="not-found-bubble media"
            data-interactive="true"
          >
            <span>Media</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
